export const CONTROL_PIN_BEGIN = 'cv/myAccount/controlPin/CONTROL_PIN_BEGIN';
export const CONTROL_PIN_ACTIVE_SUCCESS =
  'cv/myAccount/controlPin/CONTROL_PIN_ACTIVE_SUCCESS';
export const CONTROL_PIN_CHANGE_SUCCESS =
  'cv/myAccount/controlPin/CONTROL_PIN_CHANGE_SUCCESS';
export const CONTROL_PIN_CHECK_SUCCESS =
  'cv/myAccount/controlPin/CONTROL_PIN_CHECK_SUCCESS';
export const CONTROL_PIN_MODIFY_SUCCESS =
  'cv/myAccount/controlPin/CONTROL_PIN_MODIFY_SUCCESS';
export const CONTROL_PIN_REMIND_SUCCESS =
  'cv/myAccount/controlPin/CONTROL_PIN_REMIND_SUCCESS';
export const CONTROL_PIN_SET_SUCCESS =
  'cv/myAccount/controlPin/CONTROL_PIN_SET_SUCCESS';
export const CONTROL_PIN_STATUS_SUCCESS =
  'cv/myAccount/controlPin/CONTROL_PIN_STATUS_SUCCESS';
export const CONTROL_PIN_ERROR = 'cv/myAccount/controlPin/CONTROL_PIN_ERROR';
